import React, { useEffect, useState } from 'react'
import { withStyles } from '@material-ui/core'
import PropTypes from 'prop-types'

import { customStyles, styles } from './styles'
import { getBotLanguages } from '../../tabs/settings/api/settings'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'
import Select from 'react-select'

const LaguageSelector = props => {
  const { activeBotId, onChange, value } = props
  const [activeLanguages, setActiveLanguages] = useState([])
  const [selectedLanguageOption, setSelectedLanguageOption] = useState([])

  useEffect(() => {
    if (activeBotId) {
      getBotLanguages(activeBotId).then(botLanguages => {
        const { defaultLanguage, activeLanguages } = botLanguages
        const selectedOption = {
          label: defaultLanguage.fullName,
          value: defaultLanguage.shortName,
          rtl: defaultLanguage.isRtl,
        }

        const languageOptions = activeLanguages.map(language => {
          return {
            label: language.fullName,
            value: language.shortName,
            rtl: language.isRtl,
          }
        })
        onChange(selectedOption)
        setActiveLanguages(languageOptions)
        setSelectedLanguageOption(selectedOption)
      })
    }
  }, [activeBotId])

  return (
    <Select
      options={activeLanguages}
      value={value || selectedLanguageOption}
      styles={customStyles}
      onChange={onChange}
    />
  )
}

LaguageSelector.propTypes = {
  classes: PropTypes.object,
}

const mapStateToProps = state => ({
  activeBotId: state.activeBot?.id,
})

export default withRouter(
  withStyles(styles)(connect(mapStateToProps)(LaguageSelector)),
)
